import { informacoesIniciaisPedidoStyles } from './InformacoesIniciaisPedido.style'

export function informacoesIniciaisPedidoIO() {
  return {
    styles: informacoesIniciaisPedidoStyles
  }
}

export type InformacoesIniciaisPedidoIO = ReturnType<typeof informacoesIniciaisPedidoIO>
